module.exports = __webpack_public_path__ + "img/flight_attendant.2e1d540f.png";